import React, { useState, useEffect, useContext } from 'react';
import { withRouter, matchPath, useLocation } from 'react-router-dom';

import { LinkContainer } from 'react-router-bootstrap';
import { Breadcrumb } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';

const getPaths = pathname => {
    const paths = ['/']
    if (pathname === '/') return paths;
    pathname.split('/').reduce((prev, curr) => {
        const currPath = `${prev}/${curr}`
        paths.push(currPath)
        return currPath
    })
    return paths
}

const BreadcrumbRouteItem = ({ name, currPath }, fullCurrPath) => {
    if (currPath === fullCurrPath) {
        return <li key={currPath} className="sub-nav-breadcrumb-item breadcrumb-item" active="true">{name}</li>
    }
    else if (currPath === '/') {
        return <li key={currPath} className="sub-nav-breadcrumb-item breadcrumb-item">{name}</li>
    }
    else {
        return <li key={currPath} className="sub-nav-breadcrumb-item breadcrumb-item">
            <LinkContainer to={currPath}>
                <a>
                    {name}
                </a>
            </LinkContainer>
        </li>
    }
}

const NavBreadcrumb = (props) => {
    const [paths, setPaths] = useState([]);
    const [routes, setRoutes] = useState([]);
    const [pathname, setPathname] = useState('');
    const location = useLocation();

    const authContext = useContext(AuthContext);

    useEffect(() => {
        let localRoutes = authContext.currentUser?.routes ? authContext.currentUser.routes : [];
        setRoutes(localRoutes);
    }, [authContext.currentUser?.routes]);

    useEffect(() => {
        setPathname(location.pathname);
    }, [location.pathname])

    useEffect(() => {
        if (routes && routes.length > 0) {
            buildNav();
        }
    }, [pathname, routes])

    const buildNav = () => {
        let pathItems = null
        if (routes) {
            const currPath = pathname;
            const paths = getPaths(currPath)
            const currRoutes = paths.map(currPath => {
                const route = routes?.find(route => matchPath(currPath, {
                    path: route.path,
                    exact: route.exact
                }))
                return { ...route, currPath }
            }).filter(route => route.name != undefined && route.name != '')
            pathItems = currRoutes.map(route => {
                return BreadcrumbRouteItem(route, currPath)
            })
        }

        setPaths(pathItems)
    }

    return (
        <Breadcrumb className="sub-nav-breadcrumb">
            { paths }
        </Breadcrumb>
    );
}

export default NavBreadcrumb;

//class NavBreadcrumb extends Component {
//    constructor(props) {
//        super(props);
//        this.state = { items: [] };
//        this.refreshItems = this.refreshItems.bind(this);
//    }

//    //static getDerivedStateFromProps(nextProps, prevState) {
//    //    if (prevState.location === undefined || nextProps.location.pathname !== prevState.location.pathname) {
//    //        this.refreshItems();
//    //    }
//    //    else return null;
//    //}

//    //componentDidUpdate(prevProps) {
//    //    if (prevProps.location.pathname !== this.props.location.pathname) {
//    //        this.refreshItems();
//    //    }
//    //}

//    refreshItems(pathname) {
//        let items = null
//        if (this.props.routes) {
//            const currPath = pathname;
//            const paths = getPaths(currPath)
//            const currRoutes = paths.map(currPath => {
//                const route = this.props.routes.find(route => matchPath(currPath, {
//                    path: route.path,
//                    exact: route.exact
//                }))
//                return { ...route, currPath }
//            }).filter(route => route.name != undefined && route.name != '')
//            items = currRoutes.map(route => {
//                return BreadcrumbRouteItem(route, currPath)
//            })
//        }

//        return items;
//    }

//    render() {

//        return (
//            <Breadcrumb className="sub-nav-breadcrumb">
//                { this.refreshItems(this.props.location.pathname) }
//            </Breadcrumb>
//        );
//    }
//}

//export default withRouter(NavBreadcrumb);

